import { render, staticRenderFns } from "./SmallHeart.vue?vue&type=template&id=4199090e&scoped=true&"
import script from "./SmallHeart.vue?vue&type=script&lang=js&"
export * from "./SmallHeart.vue?vue&type=script&lang=js&"
import style0 from "./SmallHeart.vue?vue&type=style&index=0&id=4199090e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4199090e",
  null
  
)

export default component.exports